import { render } from "./provision.vue?vue&type=template&id=5d4d9aac&scoped=true"
import script from "./provision.vue?vue&type=script&lang=js"
export * from "./provision.vue?vue&type=script&lang=js"

import "./provision.vue?vue&type=style&index=0&id=5d4d9aac&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4d9aac"]])

export default __exports__